import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { HttpBackend, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { DecimalPipe } from '@angular/common';
import { ENVIRONMENT, LibSharedService, MaintenanceNotificationInterceptor, OneTimeTokenInterceptor, SpinnerInterceptor } from '@lib/shared';
import { environment } from '../environments/environment';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

export function TranslationLoaderFactory(handler: HttpBackend) {
	return new MultiTranslateHttpLoader(handler, [{ prefix: '../i18n/', suffix: '.json' }]);
}

export const translationInit = () => inject(LibSharedService).translationInit(environment.languages);

export const appConfig: ApplicationConfig = {
	// prettier-ignore
	providers: [
		{ provide: ENVIRONMENT, useValue: environment },
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideHttpClient(
			withInterceptors([
				MaintenanceNotificationInterceptor,
				OneTimeTokenInterceptor,
				SpinnerInterceptor
			])
		),
		provideRouter(routes),
		importProvidersFrom(
			TranslateModule.forRoot({ // https://github.com/ngx-translate/core
				loader: {
					provide: TranslateLoader,
					useFactory: TranslationLoaderFactory,
					deps: [HttpBackend]
				}
			})
		),
		provideAnimationsAsync(),
		DecimalPipe,
		provideAppInitializer(translationInit)
	]
};
